import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptGroups } from "../adapters/adaptGroup";

interface FetchParams {
	page: number;
	pageSize: number;
}

const fetchAdminGroupsPaged = async ({ page, pageSize }: FetchParams) => {
	const response = await cmsClient.get<CMSPaginatedData<IGroup>>(
		"/users/groups/",
		{
			params: {
				page,
				page_size: pageSize
			}
		}
	);

	return response.data;
};

const useAdminGroupsPaged = (page: number, pageSize: number) => {
	return useQuery(
		["admin-groups-paged", { page, pageSize }],
		() => fetchAdminGroupsPaged({ page, pageSize }),
		{
			keepPreviousData: true,
			select: (data) => ({
				...data,
				results: adaptGroups(data.results)
			})
		}
	);
};

export default useAdminGroupsPaged;
